import accountPage from "./accountPage";
import seo from "./seo";
import authPage from "./authPage";
import dashboardPage from "./dashboardPage";
import dialogs from "./dialogs";
import direction from "./direction";
import errorPage from "./errorPage";
import giftsPage from "./giftsPage";
import header from "./header";
import operationsPage from "./operationPage";
import orderPage from "./orderPage";
import pageTitles from "./pageTitles";
import pricesPage from "./pricesPage";
import ticketsPage from "./ticketPage";
import transactionsPage from "./transactionsPage";
import walletPage from "./walletPage";
import notificationDrawer from "./notificationDrawer";
import captcha from "./captcha";
import fiatPage from "./fiatPage";
import bankCard from "./bankCard";
import orderProcessPage from "./orderProcessPage";
import cropper from "./cropper";
import otpOrder from "./otpOrder";
import tradingView from "./tradingView";
import referral from "./referral";
import languages from "./languages";
import apiManagement from "./apiManagement";
import corporateAccount from "./corporateAccount";
import shared from "./shared";
// Market
import market from "./Market/market";
import assets from "./Market/assets";
import openOrders from "./Market/openOrders";
import ordersHistory from "./Market/ordersHistory";
import preconditionsHistory from "./Market/preconditionsHistory";
import stopLimitOrders from "./Market/stopLimitOrders";
import transactions from "./Market/transactions";
import common from "./Market/common";
import withdraw from "@/locales/en/Market/withdraw";
import marketsPage from "@/locales/en/Market/marketsPage";
import exchange from "@/locales/en/Market/exchange";
import sidebars from "@/locales/en/sidebars";
import staking from "./Market/staking";

export default {
  languages,
  accountPage,
  authPage,
  dashboardPage,
  dialogs,
  direction,
  errorPage,
  giftsPage,
  header,
  operationsPage,
  orderPage,
  pageTitles,
  pricesPage,
  ticketsPage,
  transactionsPage,
  walletPage,
  notificationDrawer,
  captcha,
  fiatPage,
  bankCard,
  orderProcessPage,
  cropper,
  otpOrder,
  tradingView,
  referral,
  apiManagement,
  corporateAccount,
  shared,
  // Market
  market,
  assets,
  openOrders,
  ordersHistory,
  preconditionsHistory,
  stopLimitOrders,
  transactions,
  common,
  withdraw,
  marketsPage,
  exchange,
  sidebars,
  staking,
  seo
};
